import { array, object } from 'yup'

import { genArgConverter } from '../../../utils'
import { i18nErrorCodes }  from '../form-utils'

const {
  minOneRequired,
  required,
} = i18nErrorCodes

export default object().shape({
  experiences: array()
                 .min(1, minOneRequired)
                 .required(required),
})

export const convertEditExperience = genArgConverter(
  (type, { experiences }) => [
    type,
    experiences,
  ]
)

export const emptyExperiences = {
  experiences: [],
}

export const convertExperiences = ({
  experiences
}) => ({
  experience: experiences,
})



// WEBPACK FOOTER //
// ./src/components/forms/schemas/experiences.schema.ts